var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outfit-image"},[(_vm.loaded)?_c('div',{staticClass:"none-image"},[_c('BIcon',{attrs:{"icon":"card-image"}})],1):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(!_vm.loaded)?_c('img',{attrs:{"src":_vm.outfitImg,"alt":"outfit"},on:{"load":_vm.imgLoaded,"error":_vm.onError}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }